import React from "react";
import { withRouter } from "react-router";
import axios from "axios";
import Base from "./../template/Layout/Base";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { Services } from "../../repositories/clients/Services.js";
import { SetNewListGroups } from "../../state/actions/Header";
import { ShowForRole } from "../Global/Permission";
import { roleCustomerFilter } from "../Global/Permission/constants";
import Authentication from "../../services/Authentication.js";
import SessionStorage from "../../services/SessionStorage.js";
import Loader from "../Global/Loader/index.js";
import { Heading, MODULES, MENU_HANDLER } from "./menuConfig.js";

const auth = new Authentication();
const session = new SessionStorage();

/* ===================== UTILS ===================== */

const createOffsetValue = (date) => {
  const sign = date.getTimezoneOffset() > 0 ? "-" : "+";
  const offset = Math.abs(date.getTimezoneOffset());
  const hours = Math.floor(offset / 60);
  const minutes = ((offset % 60) / 60) * 10;
  return `${sign}${hours}.${minutes}`;
};

/* ===================== COMPONENT ===================== */

function WrapperRoute(props) {
  const MainComponent = props.component;
  const { history } = props;

  /* ===================== AUTH DATA ===================== */

  const token = auth.getAuthentication("token");
  const RoleId = auth.getAuthentication("RoleId");
  const UserId = auth.getAuthentication("dataUser");
  const UserNameLast = auth.getAuthentication("UserNameLast");
  const UserName = auth.getAuthentication("UserName");
  const Role = auth.getAuthentication("Role");
  const lng = props.lng;
  const isLoggedIn = auth.getAuthentication("isLoggedIn");
  const Email = auth.getAuthentication("EmailUser");
  const ProjectId = 6;
  const modules = JSON.parse(auth.getAuthentication("Modules") || "[]");
  const allowedRoles = ["5", "6", "7", "9"];

  /* ===================== REFS DE CONTROL ===================== */

  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [authChecked, setAuthChecked] = React.useState(false);
  const navigateLoggedRef = React.useRef(false);
  
  const refreshNotifications = React.useCallback(async () => {
    if (!token || !UserId) {
      return;
    }

    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const response = await axios.get(
        `${Services.ADMIN.path}admin/notifications/${UserId}?zona=${timezone}&lang=${lng}`,
      );

      const notify = response?.data?.Notify || [];
      const currentNotify = props.notify || [];

      if (JSON.stringify(currentNotify) === JSON.stringify(notify)) {
        return;
      }

      session.updateItem("notify", JSON.stringify(notify));

      await props.SetNewListGroups({
        group_list: props.group_list,
        clients: props.clients,
        nit: props.nit,
        notify,
        lang: lng,
      });
    } catch (error) {
      console.error("refreshNotifications:", error);
    }
  }, [
    UserId,
    token,
    lng,
    props.notify,
    props.group_list,
    props.clients,
    props.nit,
    props.SetNewListGroups,
  ]);

  /* ===================== LOG NAVEGACIÓN ===================== */
  // SOLO si GetAuthentication fue exitoso

  const logNav = () => {
    console.log("navigate");

    const moduleLog = {
      UsuarioId: UserId,
      ModuleId: props.name,
      Date: new Date(),
      timezone: createOffsetValue(new Date()),
      SessionId: token,
    };

    axios.post(`${Services.AUDIT.path}modules-log/navigate`, moduleLog);
  };

  /* ===================== AUTH VALIDATION ===================== */
  // Se ejecuta en CADA render

  const GetAuthentication = async () => {
    setAuthChecked(false);

    if (!token) {
      setIsAuthenticated(false);
      setAuthChecked(true);
      return;
    }

    try {
      await axios.get(`${Services.ADMIN.path}oauth/validate?token=${token}`);

      setIsAuthenticated(true);
      setAuthChecked(true);

      logNav();
    } catch (error) {
      setIsAuthenticated(false);
      setAuthChecked(true);

      auth.deleteAuthentication("token");
      auth.deleteAuthentication("dataUser");
      auth.deleteAuthentication("customerSelect");
      auth.deleteAuthentication("isLoggedIn");

      const endSession = {
        SessionId: token,
        EndConnection: new Date(),
        timezone: createOffsetValue(new Date()),
        Logout: "1",
      };

      axios.post(`${Services.AUDIT.path}user-logs/logout`, endSession);
      history.push("/");
    }
  };

  React.useEffect(() => {
    GetAuthentication();
  }, [props.name]);

  /* ===================== BEFORE UNLOAD ===================== */

  React.useEffect(() => {
    
    if (!token) history.push("/");;

    const handleBeforeUnload = () => {
      const endSession = {
        SessionId: token,
        EndConnection: new Date(),
        timezone: createOffsetValue(new Date()),
        Logout: "0",
      };

      navigator.sendBeacon(
        `${Services.AUDIT.path}user-logs/logout`,
        JSON.stringify(endSession),
      );
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [token]);

  /* ===================== FILTER CUSTOMER ===================== */

  const FilterCustomer = React.useCallback(
    async (filterCustomer, objectId) => {
      try {
        const filter = roleCustomerFilter.find((rol) => rol.Rol === RoleId);

        if (filter && !filter.Full && filter.Filters.includes(filterCustomer)) {
          const data = {
            userId: UserId,
            objectId,
            moduleAction: filterCustomer,
          };

          const response = await axios.post(
            `${Services.ADMIN.path}general/verifyCustomerAccess`,
            data,
          );

          if (response.data.code !== 200) {
            history.push("/dashboard");
          }
        }
      } catch {
        history.push("/dashboard");
      }
    },
    [history, RoleId, UserId],
  );

  React.useEffect(() => {
    if (props.filterCustomer) {
      FilterCustomer(props.filterCustomer, props.match.params.id);
    }
  }, [props.filterCustomer, FilterCustomer]);

  React.useEffect(() => {
    refreshNotifications();
  }, [refreshNotifications, props.location.pathname, props.location.search]);

  /* ===================== MENU ===================== */

  const buildMenuFromModules = (modules, rol) => {
    const menu = [Heading];
    let activeModuleIds = Object.keys(modules).filter((id) => modules[id]);

    if (rol === "7") {
      activeModuleIds = activeModuleIds.filter((id) => id !== "6");
    }

    Object.values(MODULES).forEach((module) => {
      if (activeModuleIds.includes(String(module.id))) {
        menu.push(module);
      }
    });

    return menu;
  };

  const buildMenuFromKeys = (moduleKeys = []) => {
    const menu = [Heading];
    moduleKeys.forEach((key) => MODULES[key] && menu.push(MODULES[key]));
    return menu;
  };

  const menu =
    modules && Object.keys(modules).length > 0 && allowedRoles.includes(RoleId)
      ? buildMenuFromModules(modules, RoleId)
      : buildMenuFromKeys(MENU_HANDLER[RoleId]);

  /* ===================== LOGOUT MANUAL ===================== */

  const handleLogout = () => {
    const endSession = {
      SessionId: token,
      EndConnection: new Date(),
      timezone: createOffsetValue(new Date()),
      Logout: "1",
    };

    axios.post(`${Services.AUDIT.path}user-logs/logout`, endSession);

    auth.deleteAuthentication("token");
    auth.deleteAuthentication("dataUser");
    auth.deleteAuthentication("customerSelect");
    auth.deleteAuthentication("isLoggedIn");
    session.deleteItem("clients");
    session.deleteItem("nit");
    session.deleteItem("lang");
    session.deleteItem("group_list");

    history.push("/");
    window.location.reload();
  };

  /* ===================== RENDER ===================== */

  return (
    <Base
      Menu={{ Menu: menu }}
      SideBarConfig={{
        UserNameLast,
        UserName,
        RoleId,
        lng,
        Role,
        module: props.name,
        isLoggedIn,
      }}
      onLogout={handleLogout}
    >
      <ShowForRole
        rol={RoleId}
        accessPermission={props.accessPermission}
        modules={modules}
      >
        <MainComponent
          name={props.name}
          _user={UserId}
          _rolId={RoleId}
          _rolename={Role}
          token={token}
          UserName={UserName}
          UserNameLast={UserNameLast}
          ProjectId={ProjectId}
          Email={Email}
          _Role={Role}
          languaje={lng}
          lng="EN"
          CustomLoader={Loader}
        />
      </ShowForRole>
    </Base>
  );
}

/* ===================== REDUX / EXPORT ===================== */

const mapStateToProps = (state) => ({
  lng: state.header.lang,
  group_list: state.header.group_list,
  clients: state.header.clients,
  nit: state.header.nit,
  notify: state.header.notify,
});

const mapDispatchToProps = (dispatch) => ({
  SetNewListGroups: (new_group_list) =>
    dispatch(SetNewListGroups(new_group_list)),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(WrapperRoute)),
);
